export enum TeamType {
  INDEX,
  FORMULA,
}

export interface Team {
  id: number;
  name: string;
  shirtColor?: string;
  shortColor?: string;
  photo?: string;
  description?: string;
  logo: string;
  ownerId?: number;
}

export enum PlayerPositionEnum {
  Goalkeeper,
  //Defenders
  CenterBack,
  RightBack,
  LeftBack,
  Sweeper,
  //Midfielders
  CentralMidfielder,
  DefensiveMidfielder,
  AttackingMidfielder,
  RightWinger,
  LeftWinger,
  //Forwards
  Striker,
  SecondStriker,
}

export enum TStateEnum {
  Draft,
  RegistrationOpen,
  InProgress,
  Done,
}

export const getTStateLabel = (state: TStateEnum): string => {
  switch (state) {
    case TStateEnum.Draft:
      return 'Szkic';
    case TStateEnum.RegistrationOpen:
      return 'Rejestracja';
    case TStateEnum.InProgress:
      return 'W trakcie';
    case TStateEnum.Done:
      return 'Zakończony';
    default:
      return '';
  }
};

export interface Player {
  id: number;
  name: string;
  surname: string;
  number: string;
  position: PlayerPositionEnum;
  isCaptain: boolean;
  isDefaultRepresentative: boolean;
  soccerTeamId: number;
}

export interface TeamDefinition {
  value: string;
  type: TeamType;
}

export interface Match {
  id?: number;
  date?: string;
  teamA: TeamDefinition;
  teamB: TeamDefinition;
  venue?: string;
  locked?: boolean;
  groupId?: number;
  isFinished?: boolean;
  matchDate?: string;
  soccerTeam1Id?: number;
  soccerTeam1Goals?: number;
  soccerTeam2Id?: number;
  soccerTeam2Goals?: number;
  formula?: string;
}

export enum GroupType {
  STATIC,
  DYNAMIC,
}

export interface Group {
  id: number;
  name: string;
  teams: Team[]; // groupSoccerTeam
  groupSoccerTeams?: any[];
  matches: Match[];
  phaseId: number;
  type: GroupType; //TODO refactor with property isDynamic
  isDynamic?: boolean;
  isAddingPrevPoints: boolean;
  readiness?: boolean;
  formula?: string;
  rank: number;
}

export interface Phase {
  id: number;
  name: string;
  groups: Group[];
  isFinal: boolean;
}

export interface Enrollment {
  id: number;
  userId: number;
  soccerTeamId: number;
  soccerTeam: Team;
  expectedNumberOfPlayers: number;
  isConfirmed: boolean;
  tournamentId: number;
}

export interface Tournament {
  id: number;
  name: string;
  regulations?: string;
  phases: Phase[];
  tenantId: number;
  isLeague?: boolean;
  startDate?: string;
  state: TStateEnum;
  offerUrl?: string;
  offerDetails?: string;
  enrollments?: Enrollment[];
}

export interface PaginatedResponse<T> {
  data: Array<T>;
  page: number;
  size: number;
  totalCount: number;
}
